export class RestaurantSelector {
  constructor(configManager) {
    this.configManager = configManager;
    this.isExpanded = false;
    this.restaurants = [];
    this.isLoading = false;
    this.hasError = false;
    this.errorMessage = '';
  }

  async render() {
    if (!this.configManager.isDevMode()) {
      return '';
    }

    // Load restaurants if not already loaded
    if (this.restaurants.length === 0 && !this.isLoading && !this.hasError) {
      this.isLoading = true;
      try {
        this.restaurants = await this.configManager.getDevRestaurantOptions();
        this.hasError = false;
      } catch (error) {
        console.error('Failed to load restaurants:', error);
        this.hasError = true;
        this.errorMessage = error.message;
      }
      this.isLoading = false;
    }

    const currentId = this.configManager.getCurrentRestaurantId();

    let optionsHtml = '';
    if (this.isLoading) {
      optionsHtml = '<option>Loading restaurants...</option>';
    } else if (this.hasError) {
      optionsHtml = `<option>Error: ${this.errorMessage}</option>`;
    } else if (this.restaurants.length === 0) {
      optionsHtml = '<option>No restaurants available</option>';
    } else {
      optionsHtml = this.restaurants.map(option => `
        <option value="${option.id}" ${option.id === currentId ? 'selected' : ''}>
          ${option.name}${option.city ? ` - ${option.city}` : ''}
        </option>
      `).join('');
    }

    return `
      <div class="dev-restaurant-selector ${this.isExpanded ? 'expanded' : 'collapsed'}" id="dev-restaurant-selector">
        <div class="selector-header" id="selector-header">
          <i class="fas fa-cog"></i>
          <span>Dev Mode</span>
          <i class="fas fa-chevron-${this.isExpanded ? 'up' : 'down'} toggle-icon"></i>
        </div>
        <div class="selector-content" id="selector-content" style="display: ${this.isExpanded ? 'block' : 'none'}">
          <select id="restaurant-select" class="restaurant-select" ${this.isLoading || this.hasError ? 'disabled' : ''}>
            ${optionsHtml}
          </select>
        </div>
      </div>
    `;
  }

  bindEvents(onRestaurantChange) {
    if (!this.configManager.isDevMode()) return;

    const selector = document.getElementById('restaurant-select');
    const header = document.getElementById('selector-header');
    const content = document.getElementById('selector-content');

    // Toggle expand/collapse on header click
    if (header) {
      header.addEventListener('click', () => {
        this.isExpanded = !this.isExpanded;
        const selectorDiv = document.getElementById('dev-restaurant-selector');
        const toggleIcon = header.querySelector('.toggle-icon');
        
        if (this.isExpanded) {
          selectorDiv.classList.add('expanded');
          selectorDiv.classList.remove('collapsed');
          content.style.display = 'block';
          toggleIcon.className = 'fas fa-chevron-up toggle-icon';
        } else {
          selectorDiv.classList.add('collapsed');
          selectorDiv.classList.remove('expanded');
          content.style.display = 'none';
          toggleIcon.className = 'fas fa-chevron-down toggle-icon';
        }
      });
    }

    // Restaurant selection change
    if (selector) {
      selector.addEventListener('change', async (e) => {
        const newRestaurantId = e.target.value;
        
        // Show loading state
        selector.disabled = true;
        const originalText = selector.options[selector.selectedIndex].text;
        selector.options[selector.selectedIndex].text = 'Loading...';
        
        try {
          // Call the change handler and wait for it to complete
          await onRestaurantChange(newRestaurantId);
          
          // Force a full app reload to ensure everything updates
          window.location.reload();
        } catch (error) {
          console.error('Failed to switch restaurant:', error);
          // Restore original text on error
          selector.options[selector.selectedIndex].text = originalText;
          selector.disabled = false;
        }
      });
    }
  }


  async reloadRestaurants() {
    this.isLoading = true;
    this.restaurants = [];
    this.hasError = false;
    this.errorMessage = '';
    
    try {
      this.restaurants = await this.configManager.getDevRestaurantOptions();
      await this.updateRestaurantOptions();
    } catch (error) {
      console.error('Failed to reload restaurants:', error);
      this.hasError = true;
      this.errorMessage = error.message;
      await this.updateRestaurantOptions();
    } finally {
      this.isLoading = false;
    }
  }

  async updateRestaurantOptions() {
    const selector = document.getElementById('restaurant-select');
    if (!selector) return;

    const currentId = this.configManager.getCurrentRestaurantId();
    let optionsHtml = '';

    if (this.isLoading) {
      optionsHtml = '<option>Loading restaurants...</option>';
    } else if (this.hasError) {
      optionsHtml = `<option>Error: ${this.errorMessage}</option>`;
    } else if (this.restaurants.length === 0) {
      optionsHtml = '<option>No restaurants available</option>';
    } else {
      optionsHtml = this.restaurants.map(option => `
        <option value="${option.id}" ${option.id === currentId ? 'selected' : ''}>
          ${option.name}${option.city ? ` - ${option.city}` : ''}
        </option>
      `).join('');
    }

    selector.innerHTML = optionsHtml;
    selector.disabled = this.isLoading || this.hasError;

    // Update the header count
    const headerSpan = document.querySelector('.dev-restaurant-selector .selector-header span');
    if (headerSpan) {
      headerSpan.textContent = `Development Mode`;
    }
  }

  updateSelection(restaurantId) {
    const selector = document.getElementById('restaurant-select');
    if (selector) {
      selector.value = restaurantId;
    }
  }

  show() {
    const element = document.getElementById('dev-restaurant-selector');
    if (element) {
      element.style.display = 'block';
    }
  }

  hide() {
    const element = document.getElementById('dev-restaurant-selector');
    if (element) {
      element.style.display = 'none';
    }
  }
}